import { useEffect, useRef, useState } from 'react';

export const useDelayedBoolean = (
  value: boolean,
  delay: number = 300,
): boolean => {
  const [delayedValue, setDelayedValue] = useState(value);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (value) {
      timeoutRef.current = window.setTimeout(() => {
        setDelayedValue(true);
      }, delay);
    } else {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setDelayedValue(false);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [value, delay]);
  return delayedValue;
};
